import React from 'react';
import RootSiblings from 'react-native-root-siblings';
import { WrapperComponent } from './alert-wrapper';
export const Popup = WrapperComponent;
const show = (props) => {
    var _a;
    let newProps = props;
    const sibling = PopupManager.show(React.createElement(Popup, Object.assign({}, props, { maskStyle: Object.assign({ zIndex: 1000 }, props.maskStyle), popupStyle: Object.assign({ zIndex: 1000 }, props.popupStyle), useModal: (_a = props.useModal) !== null && _a !== void 0 ? _a : false, componentApi: false, onAnimateEnd: () => {
            props.onAnimateEnd && props.onAnimateEnd();
            sibling.destroy();
        } })));
    return {
        update: (props) => {
            newProps = props;
            sibling.update(React.createElement(Popup, Object.assign({}, props, { visible: true, componentApi: false, onAnimateEnd: () => {
                    props.onAnimateEnd && props.onAnimateEnd();
                    sibling.destroy();
                } })));
        },
        remove: () => {
            sibling.update(React.createElement(Popup, Object.assign({}, newProps, { visible: false, componentApi: false, onAnimateEnd: () => {
                    props.onAnimateEnd && props.onAnimateEnd();
                    sibling.destroy();
                } })));
        },
    };
};
Popup.show = show;
export const PopupManager = {
    show(children) {
        const sibling = new RootSiblings(children);
        return {
            update: (children) => {
                sibling.update(children);
            },
            destroy: () => {
                sibling.destroy();
            },
        };
    },
};
